const FINAL = new Set(['FT', 'AET', 'PEN', 'CANC', 'ABD', 'AWD', 'WO']);

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

// "Multipla – 4 eventi" / "Sistema – 10 eventi – 2 errori"
export const kindLabel = (sel) => {
  const ev = plural(sel.picks?.length || 0, 'evento', 'eventi');
  if (sel.kind !== 'sistema') return `Multipla – ${ev}`;
  return `Sistema – ${ev}${sel.errors_allowed ? ` – ${plural(sel.errors_allowed, 'errore', 'errori')}` : ''}`;
};

// Same rule as the backend: all matches over, a lost Fissa, or more lost bets than errors allowed
export const isOver = (sel, rows) => {
  if (!rows?.length) return false;
  if (rows.every((r) => FINAL.has(r.status))) return true;
  const fixed = (sel.picks || []).map((p) => !!p.fixed);
  const losses = rows.filter((r, i) => r.state === 'lost' && !fixed[i]).length;
  return rows.some((r, i) => r.state === 'lost' && fixed[i]) || losses > (sel.errors_allowed || 0);
};

export const matchesQuery = (sel, q) => {
  const t = q.trim().toLowerCase();
  if (!t) return true;
  const hay = [sel.description, sel.booking_code, sel.owner_name, ...(sel.picks || []).flatMap((p) => [p.home_team, p.away_team])];
  return hay.some((x) => (x || '').toLowerCase().includes(t));
};

// Left badge of a row: big outcome + small market name (e.g. "O2.5" / "U/O")
export const shortMarket = (m = '') => {
  const s = m.trim();
  let x = s.match(/^(Over|Under) (\d+(?:[.,]\d)?)$/i);
  if (x) return { o: `${x[1][0].toUpperCase()}${x[2]}`, g: 'U/O' };
  if (/^(Goal|GG)$/i.test(s)) return { o: 'GG', g: 'GG/NG' };
  if (/^(No Goal|NG)$/i.test(s)) return { o: 'NG', g: 'GG/NG' };
  if (/^[1X2]$/i.test(s)) return { o: s.toUpperCase(), g: '1X2' };
  if (/^(1X|X2|12)$/i.test(s)) return { o: s.toUpperCase(), g: 'DC' };
  x = s.match(/^Multigol (\d+-\d+)$/i);
  if (x) return { o: x[1], g: 'Multigol' };
  x = s.match(/^Risultato esatto (\d+-\d+)$/i);
  if (x) return { o: x[1], g: 'Ris. esatto' };
  x = s.match(/^([^:+]{2,30}):\s*(.+)$/);
  if (x) return { o: x[2], g: x[1] };
  return { o: s, g: '' };
};
